import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'axios';
import { API_URL, ENDPOINTS } from './constants/api';
import { decodeToken, getToken } from './utils/TokenUtils';

// Initialize i18next with basic settings
i18next.use(initReactI18next).init({
  lng: 'en', // Default language
  fallbackLng: 'en',
  resources: {
    en: {
      translation: {},
    },
  },
});

const token = getToken();
// if (!token) {
//   window.location.href = '/login/user-login';
// }
const defaultLang = decodeToken(token, 'default_lang');

let language = localStorage.getItem('language') || defaultLang; // Get language from localStorage or default to 'en'

// Function to load translations from API dynamically
export const loadTranslations = async () => {
  const url = `${API_URL}/${ENDPOINTS.SYS}/invoice/translate-to/${language}`;
  try {
    // Fetch translations from API for the specified language
    const response = await axios.get(url);

    // Parse the translations from the server response (if needed)
    const translations = JSON.parse(response.data.translations);
    //console.log('translations:', translations);
    // Add translations to i18next for the specified language
    i18next.addResourceBundle(
      language,
      'translation',
      translations,
      true,
      true
    );

    // Change the language after loading the resources
    i18next.changeLanguage(language);
  } catch (error) {
    language = 'en';
    console.error('Error fetching translations:', error);
    // notification.error({
    //   message: `Error ${error.response.status}: ${error.response.data.message || 'Unknown error'}`,
    // });
  }
};
